import React from 'react';

import { ConfirmationModal } from "components";
import { Toaster } from 'components/notification/Toaster';
import { func_validation } from 'functions';
import { useState } from 'react';

export function useAccountDeletion(props) {
    const {
        totalRequests,
        selectedAccount,
        deleteAccount_requesting
    } = props;
    
    const [isModalVisible_deleteAccount, setIsModalVisible_deleteAccount] = useState(false);

    function deleteAccount() {
        if (func_validation.isFunction(props.setAlertMsg)) props.setAlertMsg([]);
    
        if (func_validation.isArrayNotEmpty(selectedAccount)) {           
            selectedAccount.map((accountDetails, idx) => { 
                let accountId = func_validation.getObjectPropertyValue(accountDetails, "Id");
    
                if (func_validation.isNumberValid(accountId) &&
                    func_validation.isFunction(props.deleteAccount)) {
    
                    props.deleteAccount(accountId);
                }
            });
        }
        else {
            Toaster({
                type: "info",
                msg: "Please select at least 1 account.",
            });
        }
    }

    let deleteModal = (
        <ConfirmationModal
            description={"The selected account(s) will be deleted."}
            cancelButtonText={"Cancel"}
            confirmButtonText={"Confirm"}

            isModalVisible={isModalVisible_deleteAccount}
            updateParentState={setIsModalVisible_deleteAccount}
            handleOnConfirm={deleteAccount}
            isActionLoading={deleteAccount_requesting}
            isConfirmSuccessful={totalRequests == 0}
        />
    );

    return {
        deleteAccount,
        setIsModalVisible_deleteAccount,
        deleteModal
    };
}